import React, { FC, useEffect, useState } from 'react';
import { Icons } from '@components/Icon';
import { IconTemplate } from '@components/Icon/IconTemplate';
import useTranslation from '@hooks/useTranslation';
import TitleTemplate, { TitleTagTypes } from '@ui/SectionTitle/Title';
import { publicAssets } from '@utils/url.utils';
import ContentWrapper from '../../ui/Content/Content';
import { Area, Areas, Column, Image, ShowMoreButton, Wrapper } from './Education.elements';

interface EducationProps {}

const EducationTemplate: FC<EducationProps> = () => {
    const { t } = useTranslation();

    const [showAllEducations, setShowAllEducations] = useState(true);

    useEffect(() => {
        if (window.innerWidth < 480) {
            setShowAllEducations(false);
        }
    }, []);

    return (
        <ContentWrapper mobileSidePadding={20}>
            <Wrapper>
                <div>
                    <TitleTemplate tagType={TitleTagTypes.H2} alignLeft isBlack>
                        {t('about.education.title')}
                    </TitleTemplate>
                    <Areas>
                        <Column>
                            <Area>
                                <IconTemplate name={Icons.ArrowRight} />
                                {t('about.education.area1')}
                            </Area>
                            <Area>
                                <IconTemplate name={Icons.ArrowRight} />
                                {t('about.education.area2')}
                            </Area>
                            <Area>
                                <IconTemplate name={Icons.ArrowRight} />
                                {t('about.education.area3')}
                            </Area>
                            <Area>
                                <IconTemplate name={Icons.ArrowRight} />
                                {t('about.education.area4')}
                            </Area>
                            <Area>
                                <IconTemplate name={Icons.ArrowRight} />
                                {t('about.education.area5')}
                            </Area>
                            <Area>
                                <IconTemplate name={Icons.ArrowRight} />
                                {t('about.education.area6')}
                            </Area>
                            <Area>
                                <IconTemplate name={Icons.ArrowRight} />
                                {t('about.education.area7')}
                            </Area>
                        </Column>
                        {showAllEducations && (
                            <Column>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area8')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area9')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area10')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area11')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area12')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area13')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area14')}
                                </Area>
                                <Area>
                                    <IconTemplate name={Icons.ArrowRight} />
                                    {t('about.education.area15')}
                                </Area>
                            </Column>
                        )}
                    </Areas>
                    <ShowMoreButton onClick={() => setShowAllEducations(!showAllEducations)}>
                        {showAllEducations
                            ? t('about.customers.button.showLess')
                            : t('about.customers.button.showMore')}
                    </ShowMoreButton>
                </div>
                <Image src={publicAssets('/education.svg')} />
            </Wrapper>
        </ContentWrapper>
    );
};
export default EducationTemplate;
